import { NavLink, useNavigate } from "react-router-dom";
import {
  Activity,
  Cpu,
  FileCode2,
  Database,
  Settings,
  Power,
  Server,
  Terminal,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const items = [
  { to: "/", icon: Activity, label: "Dashboard", testId: "sidebar-nav-dashboard" },
  { to: "/processes", icon: Cpu, label: "Prozesse", testId: "sidebar-nav-processes" },
  { to: "/services", icon: Server, label: "Services", testId: "sidebar-nav-services" },
  { to: "/nginx", icon: FileCode2, label: "Nginx", testId: "sidebar-nav-nginx" },
  { to: "/mongo", icon: Database, label: "MongoDB", testId: "sidebar-nav-mongodb" },
  { to: "/settings", icon: Settings, label: "Einstellungen", testId: "sidebar-nav-settings" },
];

export default function Sidebar() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <aside
      data-testid="app-sidebar"
      className="w-60 shrink-0 bg-[#0a0a0a] grid-border-r flex flex-col"
      style={{ borderRight: "1px solid #1f1f22" }}
    >
      <div className="px-4 h-14 flex items-center gap-2 grid-border-b">
        <Terminal className="w-4 h-4 text-[#22d3ee]" strokeWidth={1.5} />
        <span className="text-sm font-mono tracking-[0.15em] uppercase text-white">
          armesa<span className="text-[#22d3ee]">.mon</span>
        </span>
      </div>

      <nav className="py-2 flex-1">
        {items.map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              [
                "flex items-center gap-3 px-4 py-2.5 text-sm font-mono tracking-wide transition-colors",
                "border-l-2 border-transparent",
                isActive
                  ? "bg-[#111111] text-white border-l-[#22d3ee]"
                  : "text-[#8b8d98] hover:text-white hover:bg-[#0f0f0f]",
              ].join(" ")
            }
          >
            <Icon className="w-4 h-4" strokeWidth={1.5} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-3 grid-border-t">
        <div className="px-1 pb-3 flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-[#10b981] pulse-dot" />
          <span className="text-[11px] font-mono tracking-[0.2em] uppercase text-[#8b8d98]">
            online · {user?.username}
          </span>
        </div>
        <button
          data-testid="sidebar-logout-button"
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-[0.15em] border border-[#1f1f22] text-[#8b8d98] hover:text-[#dc2626] hover:border-[#dc2626] transition-colors"
        >
          <Power className="w-3.5 h-3.5" strokeWidth={1.5} />
          Logout
        </button>
      </div>
    </aside>
  );
}
